import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Spinner } from "bizpandit-ui";
import { Sidebar } from "@/shared/layout/Sidebar";
import  Navbar  from "@/shared/layout/Navbar";
import { useUiStore } from "@/stores/uiStore";
import { useAuthStore } from "@/stores/authStore";
import { cn } from "@/lib/utils";

/**
 * Primary authenticated shell: sidebar + navbar + routed content.
 * Sidebar/Navbar are app-owned (see shared/layout) — bizpandit-ui-1 only
 * supplies UI primitives, not page-level chrome.
 */
export function AppLayout() {
  const isSidebarCollapsed = useUiStore((s) => s.isSidebarCollapsed);
  const toggleSidebar = useUiStore((s) => s.toggleSidebar);
  const user = useAuthStore((s) => s.user);

  return (
    <div className="min-h-screen bg-surface">
      <Sidebar collapsed={isSidebarCollapsed} onToggle={toggleSidebar} />

      <div
        className={cn(
          "flex min-h-screen flex-col transition-all duration-300",
          isSidebarCollapsed ? "ml-16" : "ml-[200px]",
        )}
      >
        <Navbar user={user} onToggleSidebar={toggleSidebar} />

        <main className="flex-1 p-4 sm:p-6 lg:p-4">
          <Suspense
            fallback={
              <div className="flex h-64 items-center justify-center">
                <Spinner size="lg" />
              </div>
            }
          >
            <Outlet />
          </Suspense>
        </main>
      </div>
    </div>
  );
}
